import axios from "../axiosSetup";
import { clearAuth } from "../auth";

export const logout = async () => {
  try {
    await axios.post("/auth/logout");
  } catch {
    // ignore 401 / already logged out
  } finally {
    clearAuth();
    localStorage.clear();
    sessionStorage.clear();
  }
};
